import React from 'react';
import { Pagination, List, Edit, Create, Filter, SimpleForm, DatagridConfigurable, TextField, TextInput, ReferenceInput, ReferenceField, SelectInput } from 'react-admin';
import { stripedDataGridSx } from './styles/dataGridStyles';
import Empty from './components/Empty';
import LandscapeIcon from '@mui/icons-material/Landscape';

const ProductFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Product" source="id" reference="products" allowEmpty>
            <SelectInput optionText="Product" />
        </ReferenceInput>
    </Filter>
);

const ProductPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const ProductList = props => {
    return (
        <List
            filters={<ProductFilter />}
            sort={{ field: 'Product', order: 'ASC' }}
            perPage={100}
            pagination={<ProductPagination />}
            bulkActionButtons={false}
            empty={<Empty icon={LandscapeIcon} title="No products yet" description="Create your first product to get started" />}
            {...props}
        >
            <DatagridConfigurable
                rowClick="edit"
                sx={stripedDataGridSx}
            >
                <TextField source="Product" />
                <ReferenceField label="Units" source="UnitID" reference="units" link={false}>
                    <TextField source="Units" />
                </ReferenceField>
                <TextField source="Charge" />
                <TextField source="Classification" />
                <TextField source="Color" />
                <TextField source="Dye" />
                <TextField source="Grind" />
                <TextField source="LifeCycle_Phase" />
                <TextField source="Market_Segment" />
                <TextField source="Size" />
                <TextField source="Species" />
                <TextField source="Quantity_In_Stock" />
                <TextField source="Warning_Threshold" />
            </DatagridConfigurable>
        </List>
    )
}

export const ProductEdit = props => (
    <Edit undoable={false} {...props}>
        <SimpleForm>
            <TextInput disabled label="ID" source="id" />
            <TextInput label="Product" source="Product" />
            <ReferenceInput
                label="Units"
                source="UnitID"
                reference="units">
                <SelectInput label="Units" optionText="Units" />
            </ReferenceInput>
            <TextInput label="Charge" source="Charge" />
            <TextInput label="Classification" source="Classification" />
            <TextInput label="Color" source="Color" />
            <TextInput label="Dye" source="Dye" />
            <TextInput label="Grind" source="Grind" />
            <TextInput label="LifeCycle Phase" source="LifeCycle_Phase" />
            <TextInput label="Market Segment" source="Market_Segment" />
            <TextInput label="Size" source="Size" />
            <TextInput label="Species" source="Species" />
            <TextInput label="Quantity In Stock" source="Quantity_In_Stock" />
            <TextInput label="Warning Threshold" source="Warning_Threshold" />
            <TextInput label="Configuration ID" source="ConfigurationID" />
            <TextInput label="Description" source="Description" />
            <TextInput label="A Quantity" source="A_Quantity" />
        </SimpleForm>
    </Edit>
);

export const ProductCreate = props => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput label="Product" source="Product" />
            <ReferenceInput
                label="Units"
                source="UnitID"
                reference="units">
                <SelectInput label="Units" optionText="Units" />
            </ReferenceInput>
            <TextInput label="Charge" source="Charge" />
            <TextInput label="Classification" source="Classification" />
            <TextInput label="Color" source="Color" />
            <TextInput label="Dye" source="Dye" />
            <TextInput label="Grind" source="Grind" />
            <TextInput label="LifeCycle Phase" source="LifeCycle_Phase" />
            <TextInput label="Market Segment" source="Market_Segment" />
            <TextInput label="Size" source="Size" />
            <TextInput label="Species" source="Species" />
            <TextInput label="Quantity In Stock" source="Quantity_In_Stock" />
            <TextInput label="Warning Threshold" source="Warning_Threshold" />
            <TextInput label="Configuration ID" source="ConfigurationID" />
            <TextInput label="Description" source="Description" />
            <TextInput label="A Quantity" source="A_Quantity" />
        </SimpleForm>
    </Create>
);
